import { AlertList, alertIgnore, alertTreated, batchIgnore, getAlarmList, getDevice } from '@/api';
import { useTableRequest } from '@/hooks';
import useAuthButton from '@/hooks/useAuthButton';
import { ArrowsAltOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { Badge, Button, Card, DatePicker, Form, Input, Modal, Popconfirm, Select, Space, Table, Tooltip, Typography, message } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;
const { useMessage } = message;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

export interface DeviceAlarmTabProps {
  deviceId: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DeviceAlarmTab: React.FC<DeviceAlarmTabProps> = ({ deviceId }) => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = useMessage();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  console.log('deviceId', deviceId);

   // 获取表格数据接口
   const { loading, dataSource, pagination, form, reload, search, reset } = useTableRequest<AlertList>({
    onRequest: (params) => {
    
      return getAlarmList({
        ...params,
        trigger_start_time: params.trigger_time?.[0].valueOf(),
        trigger_end_time: params.trigger_time?.[1].valueOf(),
        trigger_time: undefined,
      });
    },
  });

  interface DataType {
    id: any;
    status: string;
  }
  const [open, setOpen] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<DataType | null>(null);

  const showModal = (record: DataType) => {
    setCurrentRecord(record);
    setOpen(true);
  };

  const handleOk = async () => {
    // 处理逻辑
    const text = await form.validateFields();
    const { message } = text;
    const vaules = {
      id: currentRecord?.id,
      message,
    };
    alertTreated(vaules).then((resp) => {
      if (resp.success) {
        messageApi.open({ type: 'success', content: '处理成功' });
        setOpen(false);
        reload();
      } else {
        messageApi.open({ type: 'error', content: resp.errorMsg });
      }
    });
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };


  const { checkPermissionDisabled } = useAuthButton();
  const { data: deviceData } = useRequest(getDevice, { defaultParams: [{ isAll: true }] });
  
  // 当 deviceId 传入时，设置表单默认值并触发查询
  useEffect(() => {
    if (deviceId) {
      form.setFieldsValue({ device_id: deviceId });
      // 自动触发查询
      search();
    }
  }, [deviceId]);

  return (
    <div>
     {contextHolder}
      <Form layout="inline" className="ml20 mt20" form={form}>
        <Form.Item key="alert_level" name="alert_level">
          <Select
            placeholder="告警级别"
            style={{ width: 90 }}
            allowClear
            options={[
              { value: '', label: '全部' },
              { value: '紧急', label: '紧急' },
              { value: '重要', label: '重要' },
              { value: '次要', label: '次要' },
              { value: '提示', label: '提示' },
            ]}
          />
        </Form.Item>
        <Form.Item key="status" name="status">
          <Select
            placeholder="告警状态"
            style={{ width: 90 }}
            allowClear
            options={[
              { value: '', label: '全部' },
              { value: '未处理', label: '未处理' },
              { value: '已处理', label: '已处理' },
              { value: '忽略', label: '忽略' },
            ]}
          />
        </Form.Item>
        <Form.Item key="device_id" name="device_id">
          <Select
            options={deviceData?.result?.list || []}
            allowClear
            showSearch
            optionFilterProp="name"
            placeholder="请选择设备"
            style={{ width: 120 }}
            fieldNames={{ label: 'name', value: 'id' }}
           disabled
          ></Select>
        </Form.Item>
        <Form.Item key="name" name="name">
          <Input style={{ width: 220 }} addonBefore="告警规则名称" allowClear placeholder="请输入搜索内容"></Input>
        </Form.Item>
        <Form.Item key="trigger_time" name="trigger_time" label="触发时间">
          <RangePicker style={{ width: 300 }} showTime={{ format: 'HH:mm:ss' }} format="YYYY-MM-DD HH:mm:ss" placeholder={['开始时间', '结束时间']} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={search} disabled={checkPermissionDisabled('alarm:rule:query')}>
            查询
          </Button>
        </Form.Item>
        <Form.Item>
          <Button type="default" onClick={reset}>
            重置
          </Button>
        </Form.Item>
        <Form.Item>
          <Popconfirm
            title="此操作将忽略这些记录, 是否继续?"
            okText="确定"
            cancelText="取消"
            placement="top"
            disabled={!selectedRowKeys.length}
            onConfirm={() => {
              batchIgnore({ id: selectedRowKeys as string[] }).then((resp) => {
                if (resp.success) {
                  messageApi.open({ type: 'success', content: '操作成功' });
                  setSelectedRowKeys([]);
                  reload();
                } else {
                  messageApi.open({ type: 'error', content: resp.errorMsg });
                }
              });
            }}
          >
            <Button disabled={!selectedRowKeys.length}>批量忽略</Button>
          </Popconfirm>
        </Form.Item>
      </Form>
      <Card className="m20" size="small">
        <Table
          loading={loading}
          dataSource={dataSource}
          pagination={pagination}
          rowKey="id"
          size="small"
          rowSelection={{
            selectedRowKeys,
            columnWidth: 20,
            onChange: (newSelectedRowKeys: React.Key[]) => {
              setSelectedRowKeys(newSelectedRowKeys);
            },
            getCheckboxProps: (record: DataType) => ({
              disabled: record.status === '忽略',
            }),
          }}
          columns={[
            { title: '告警ID', key: 'id', dataIndex: 'id', width: '6em' },
            { title: '告警规则名称', key: 'name', dataIndex: 'name', width: '8em' },
            // {
            //   title: '触发告警数据',
            //   key: 'alert_result',
            //   dataIndex: 'alert_result',
            //   ellipsis: true,
            //   width: 130,
            //   render (value) {
            //     return value
            //       ? <>
            //         <Tooltip placement="bottom" title={value}>
            //           <Space><ArrowsAltOutlined style={{ color: '#1890ff' }} /> </Space>
            //         </Tooltip>
            //         {value}
            //       </>
            //       : '-'
            //   },
            // },
            { title: '告警等级', key: 'alert_level', dataIndex: 'alert_level', width: 70 },
            {
              title: '触发时间',
              key: 'trigger_time',
              dataIndex: 'trigger_time',
              width: 80,
              render(value) {
                return value === 0 ? '-' : dayjs(value).format('YYYY-MM-DD HH:mm:ss');
              },
            },
            {
              title: '处理时间',
              key: 'treated_time',
              dataIndex: 'treated_time',
              width: 80,
              render(value) {
                return value === 0 ? '-' : dayjs(value).format('YYYY-MM-DD HH:mm:ss');
              },
            },
            {
              title: '告警状态',
              key: 'status',
              dataIndex: 'status',
              width: '6em',
              render(value, record) {
                return (
                  <>
                    {value && (
                      <Badge
                        color={
                          {
                            已处理: 'green',
                            忽略: 'gray',
                            未处理: 'orange',
                          }[record.status] || 'gray'
                        }
                      />
                    )}
                    <Text className="ml5">{value || '-'}</Text>
                  </>
                );
              },
            },
            {
              title: '处理结果',
              key: 'message',
              dataIndex: 'message',
              ellipsis: true,
              width: 130,
              render(value) {
                return value ? (
                  <>
                    <Tooltip placement="bottom" title={value}>
                      <Space>
                        <ArrowsAltOutlined style={{ color: '#1890ff' }} />{' '}
                      </Space>
                    </Tooltip>
                    {value}
                  </>
                ) : (
                  '-'
                );
              },
            },
            {
              title: '操作',
              key: 'action',
              dataIndex: 'action',
              width: '8em',
              render(text: string, record: DataType) {
                return (
                  <Space split={<Text type="secondary">/</Text>}>
                    <Typography.Link disabled={checkPermissionDisabled('alarm:rule:deal') || record.status === '已处理'} onClick={() => showModal(record)}>
                      处理
                    </Typography.Link>
                    <Popconfirm
                      title="此操作将忽略该条记录, 是否继续?"
                      okText="确定"
                      cancelText="取消"
                      placement="topRight"
                      disabled={checkPermissionDisabled('alarm:rule:ignore')}
                      onConfirm={() => {
                        alertIgnore(record?.id).then((resp) => {
                          if (resp.success) {
                            messageApi.open({ type: 'success', content: '操作成功' });
                            reload();
                          } else {
                            messageApi.open({ type: 'error', content: resp.errorMsg });
                          }
                        });
                      }}
                    >
                      <Typography.Link disabled={checkPermissionDisabled('alarm:rule:ignore') || record.status === '忽略'}>忽略</Typography.Link>
                    </Popconfirm>
                    <Typography.Link
                      onClick={() => {
                        const { code, device_id, trigger, end_at, start_at } = JSON.parse((record as any).alert_result);
                        navigate(
                          `/gateway/device/detail/${encodeURIComponent(device_id)}?code=${encodeURIComponent(code)}&trigger=${encodeURIComponent(trigger)}&end_at=${encodeURIComponent(
                            end_at,
                          )}&start_at=${encodeURIComponent(start_at)}`,
                        );
                      }}
                      disabled={checkPermissionDisabled('alarm:rule:data')}
                    >
                      数据定位
                    </Typography.Link>
                  </Space>
                );
              },
            },
          ]}
        />
      </Card>
      <Modal open={open} onOk={handleOk} onCancel={handleCancel} okText="确定" cancelText="取消" maskClosable={false}>
        <Form form={form} layout="vertical">
          <Form.Item label="处理意见" name="message" rules={[{ required: true, message: '请输入处理意见' }]}>
            <TextArea placeholder="请输入处理意见" rows={4}></TextArea>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DeviceAlarmTab;

